import {IWebsiteSidebarSimpleItem} from "./website-sidebar-simple-item/website-sidebar-simple-item.model";
import {IWebsiteSidebarSubMenu} from "./website-sidebar-sub-menu/website-sidebar-sub-menu.model";
import {WebsiteSidebarSimpleItemDirector} from "./website-sidebar-simple-item/website-sidebar-simple-item.director";
import {WebsiteSidebarSubMenuDirector} from "./website-sidebar-sub-menu/website-sidebar-sub-menu.director";

export type IWebsiteSidebarList = (IWebsiteSidebarSimpleItem | IWebsiteSidebarSubMenu)[];

export type WebsiteSidebarListFactoryType =
  'networkParentSubFolder' | 'networkParentSubDomain' | 'networkChildSubFolder' | 'networkChildSubDomain'
  | 'hostedLive' | 'hostedLiveStagingEnabled' | 'hostedDev' | 'oneProductOrBundleConnected' | 'oneProductOrBundleConnectedWithBooster'
  | 'boosterDisconnected' | 'boosterDisabled' | 'boosterDisabledDev' | 'booster' | 'boosterOnly' | 'boosterConnected'
  | 'boosterConnectedPaid' | 'ecommerce' | 'ecommerceActive' | 'professional';

export class WebsiteSidebarListFactory {
  static create(type: WebsiteSidebarListFactoryType): IWebsiteSidebarList {
    switch (type) {
      case 'networkParentSubFolder':
        return networkParentSubFolder();
      case 'networkParentSubDomain':
        return networkParentSubDomain();
      case 'networkChildSubFolder':
        return networkChildSubFolder();
      case 'networkChildSubDomain':
        return networkChildSubDomain();
      case "hostedLive":
        return hostedLive();
      case "hostedLiveStagingEnabled":
        return hostedLiveStagingEnabled();
      case "hostedDev":
        return hostedDev();
      case "oneProductOrBundleConnected":
        return oneProductOrBundleConnected();
      case "oneProductOrBundleConnectedWithBooster":
        return oneProductOrBundleConnectedWithBooster();
      case "boosterDisconnected":
        return boosterDisconnected();
      case "boosterDisabled":
        return boosterDisabled();
      case "boosterDisabledDev":
        return boosterDisabledDev();
      case "booster":
        return booster();
      case "boosterConnected":
        return boosterConnected();
      case "boosterOnly":
        return boosterOnly();
      case "boosterConnectedPaid":
        return boosterConnectedPaid();
      case "ecommerceActive":
        return ecommerceActive();
      default:
        throw new Error(`cannot construct "Sidebar List" of type ${type}`);
    }
  }
}

function networkParentSubFolder(): IWebsiteSidebarList {
  return [
    WebsiteSidebarSimpleItemDirector.construct('mySites'),
    WebsiteSidebarSimpleItemDirector.construct('main'),
    WebsiteSidebarSimpleItemDirector.construct('domains'),
    WebsiteSidebarSimpleItemDirector.construct('backup'),
    WebsiteSidebarSubMenuDirector.construct('hostingParentSubFolder'),
  ];
}

function networkParentSubDomain(): IWebsiteSidebarList {
  return [
    WebsiteSidebarSimpleItemDirector.construct('mySites'),
    WebsiteSidebarSimpleItemDirector.construct('main'),
    WebsiteSidebarSimpleItemDirector.construct('backup'),
    WebsiteSidebarSubMenuDirector.construct('hostingParentSubDomain'),
  ];
}

function networkChildSubFolder(): IWebsiteSidebarList {
  return [
    WebsiteSidebarSimpleItemDirector.construct('main'),
    WebsiteSidebarSimpleItemDirector.construct('imageOptimizer'),
    WebsiteSidebarSubMenuDirector.construct('hostingChildSubFolder'),
    WebsiteSidebarSubMenuDirector.construct('products'),
  ];
}

function networkChildSubDomain(): IWebsiteSidebarList {
  return [
    WebsiteSidebarSimpleItemDirector.construct('main'),
    WebsiteSidebarSimpleItemDirector.construct('domains'),
    WebsiteSidebarSimpleItemDirector.construct('imageOptimizer'),
    WebsiteSidebarSubMenuDirector.construct('hostingChildSubDomain'),
    WebsiteSidebarSubMenuDirector.construct('products'),
  ];
}

function hostedLive(): IWebsiteSidebarList {
  return [
    WebsiteSidebarSimpleItemDirector.construct('main'),
    WebsiteSidebarSimpleItemDirector.construct('ecommerce'),
    WebsiteSidebarSimpleItemDirector.construct('domains'),
    WebsiteSidebarSimpleItemDirector.construct('backup'),
    WebsiteSidebarSubMenuDirector.construct('hostingLive'),
    WebsiteSidebarSubMenuDirector.construct('products'),
      WebsiteSidebarSubMenuDirector.construct('booster'),
  ];
}

function hostedLiveStagingEnabled(): IWebsiteSidebarList {
  return [
    WebsiteSidebarSimpleItemDirector.construct('main'),
    WebsiteSidebarSimpleItemDirector.construct('ecommerce'),
    WebsiteSidebarSimpleItemDirector.construct('domains'),
    WebsiteSidebarSimpleItemDirector.construct('backup'),
    WebsiteSidebarSubMenuDirector.construct('hostingLiveStagingEnabled'),
    WebsiteSidebarSubMenuDirector.construct('products'),
      WebsiteSidebarSubMenuDirector.construct('booster'),
  ];
}

function hostedDev(): IWebsiteSidebarList {
  return [
    WebsiteSidebarSimpleItemDirector.construct('main'),
    WebsiteSidebarSimpleItemDirector.construct('ecommerce'),
    WebsiteSidebarSimpleItemDirector.construct('domains'),
    WebsiteSidebarSimpleItemDirector.construct('backup'),
    WebsiteSidebarSubMenuDirector.construct('hostingDev'),
    WebsiteSidebarSubMenuDirector.construct('products'),
      WebsiteSidebarSubMenuDirector.construct('boosterDev'),
  ];
}

function oneProductOrBundleConnected(): IWebsiteSidebarList {
  return [
    WebsiteSidebarSimpleItemDirector.construct('plugins'),
  ];
}

function oneProductOrBundleConnectedWithBooster(): IWebsiteSidebarList {
  return [
    WebsiteSidebarSubMenuDirector.construct('booster'),
    WebsiteSidebarSimpleItemDirector.construct('plugins')
  ];
}

function boosterDisconnected(): IWebsiteSidebarList {
  return [
    WebsiteSidebarSimpleItemDirector.construct('boosterDisconnected')
  ];
}

function boosterDisabled(): IWebsiteSidebarList {
  return [
    WebsiteSidebarSimpleItemDirector.construct('boosterDisabled')
  ];
}

function boosterDisabledDev(): IWebsiteSidebarList {
  return [
    WebsiteSidebarSubMenuDirector.construct('boosterDisabledDev')
  ];
}

function booster(): IWebsiteSidebarList {
  return [
    WebsiteSidebarSimpleItemDirector.construct('boosterMain')
  ];
}

function boosterConnected(): IWebsiteSidebarList {
  return [
    WebsiteSidebarSubMenuDirector.construct('booster'),
  ];
}

function boosterOnly(): IWebsiteSidebarList {
  return [
    WebsiteSidebarSubMenuDirector.construct('boosterOnly'),
  ];
}

function boosterConnectedPaid(): IWebsiteSidebarList {
  return [
    WebsiteSidebarSubMenuDirector.construct('booster'),
    WebsiteSidebarSimpleItemDirector.construct('referralProgram')
  ];
}

function ecommerceActive(): IWebsiteSidebarList {
  return [
    WebsiteSidebarSubMenuDirector.construct('ecommerceActive'),
  ];
}
